import { stateRoot } from '../store';
import estadosCidades from './estados-cidades.json';
import * as Roles from '../constants/role';

const isLogin = () => {
  if (stateRoot().auth.token) return true;
  return false;
}

const isPublicRouter = path => {
  if (path === '/esqueci-senha') return true;
  return false;
}

const sortArray = (a, b, property = 'nome') => {
  if (a[property] > b[property]) return 1;
  else if (a[property] < b[property]) return -1;
  return 0;
}

const getEstados = () => {
  return estadosCidades.estados.map(data => ({ id: data.sigla, nome: data.nome }));
}

const getCidades = () => {
  let cidades = [];
  estadosCidades.estados.forEach(estado => {
    cidades = [...cidades, ...estado.cidades.map(cidade => ({ id: cidade, nome: cidade, estado: estado.sigla }))];
  });
  
  return cidades.sort((a, b) => {
    if (a.nome > b.nome) return 1;
    else if (a.nome < b.nome) return -1;
    return 0;
  });
}

/* 
* Este método ordena o objeto que possui o atributo codigo de forma crescente
* Obs.: O atributo código é string
*/
const ordenarPorCodigoString = (a, b) => {
  return a.codigo.localeCompare(b.codigo);
};

/* 
* Este método ordena o objeto que possui o atributo codigo de forma crescente
* Obs.: O atributo código é numerico
*/
const ordenarPorCodigoNumerico = (a, b) => {
  return parseInt(a.codigo) - parseInt(b.codigo);
};

const getMaxColumnLength = value => {
  return value && value.length > 79 ? value.substring(0,80) + "..." : value;
}

const codeFormatter = (code, totalLength = 3) => {
  if (code) {
    return `${String(code).padStart(totalLength, '0')}`;
  }
  return "";
}

const moneyFormatter = (value) => {
  if (value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  return "";
}

const isTrue = (value) => {
  if (Boolean(value)) {
    return value.toString() === "true";
  }
  return false;
}

const isFalse = (value) => {
  return !isTrue(value);
}

const isValidTime = value => {
  if (isNullOrUndefined(value)) return false;

  const match = value.match(/^([01]\d|2[0-3]):([0-5]\d)$/);
  if (!match) return false;
  
  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  
  return hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;
}

const convertTimeToMinutes = value => {
  if (!isNullOrUndefined(value) && isValidTime(value)) {
    const splited = value.split(':');
    return parseInt(splited[0] * 60) + parseInt(splited[1]);
  }

  return null;
}

const formatToTime = value => {
  const hours = Math.floor(parseInt(value) / 60);
  const minutes = parseInt(value) % 60;

  return String(hours).padStart(2, '0') + ":" + String(minutes).padStart(2, '0');
};

const isNullOrUndefined = value => {
  return value === null || value === undefined || (value && value.trim() === "");
}

const isUsuarioUsoMuto = email => process.env.REACT_APP_USUARIO_USO_MUTUO.split(',').includes(email);

const isInspecaoMtBt = tipoServicoId => tipoServicoId === "374aa79b-0ce2-4b45-9c55-ae20ec5c5e25";
const isUsoMutuo = tipoServicoId => tipoServicoId === INSPECAO_USUO_MUTUO_ID;
const isInspecaoFibraOptica = tipoServicoId => tipoServicoId === "374aa79b-0ce2-4b45-9c55-ae20ec5c5e21";
const isInspecaoAnticorrocao = tipoServicoId => tipoServicoId === INSPECAO_TRATAMENTO_ANTICORROCAO_ID;
const isInspecaoTermografica = (tipoServicoId, subTipoServicoId) => isInspecaoMtBt(tipoServicoId) && subTipoServicoId === "374aa79b-0ce2-4b45-9c55-ae20ec5c5e36"

const buildRequiredSchema = fields => fields.reduce((result, field) => {
  result[field] = { 
    presence: { allowEmpty: false, message: 'é obrigatório' }
  };
  return result;
}, {});

const isBlankString = (value, fallback = 'N/A') => {
  const isBlank = (value == null || (typeof value === 'string' && value.trim() === ''));
  return isBlank ? fallback : value;
};

const isAdmin = userRole => userRole === Roles.ADMIN || userRole === Roles.SUPER_ADMIN;
const isNotAdmin = userRole => !isAdmin(userRole);

export const VINICIUS_ADMIN_EMAIL = "vinicius_admin";
export const INSPECAO_TRATAMENTO_ANTICORROCAO_ID = "374aa79b-0ce2-4b45-9c55-ae20ec5c5e23";
export const INSPECAO_USUO_MUTUO_ID = "374aa79b-0ce2-4b45-9c55-ae20ec5c5e27";

export {
  isLogin,
  isPublicRouter,
  sortArray,
  getEstados,
  getCidades,
  ordenarPorCodigoString,
  ordenarPorCodigoNumerico,
  getMaxColumnLength,
  codeFormatter,
  moneyFormatter,
  isTrue,
  isFalse,
  isNullOrUndefined,
  isUsoMutuo,
  isUsuarioUsoMuto,
  isInspecaoMtBt,
  isValidTime,
  convertTimeToMinutes,
  formatToTime,
  isInspecaoAnticorrocao,
  buildRequiredSchema,
  isInspecaoFibraOptica,
  isInspecaoTermografica,
  isBlankString,
  isAdmin,
  isNotAdmin,
}
